const email = /^[^@\s]+@[^@\s]+\.[^@\s]+$/
const blank = /^$/

export let RegexHelper = {
  presence: /^(.|\s)*\S(.|\s)*$/, // non-blank && non-empty
  email: email, // email
  emailOrBlank: new RegExp(`${email.source}|${blank.source}`), // email or blank
  number: /^[-+]?[0-9]*\.?[0-9]+$|^$/, // number or blank;
  commaSeparatedNumber: /^[-+]?[0-9,]*\.?[0-9]+$|^$/, // number with optional commas or blank;
  alphanumeric: /^[0-9a-zA-Z]+$|^$/, // alphanumeric or blank
  phone: /^[2-9]\d{2}-\d{3}-\d{4}(?: .+)?$|^$/, // phone or blank
  zip: /^\d{5}(?:-\d{4})?$|^$/, // zip code or blank
  url: /^(?:[a-zA-Z][\w]*:\/\/)?[\w.:@-]+(?:\.[\w.-]+)+[\w\-._~:\/?#\[\]@!%$&'()*+,;=]+$|^$/, // url or blank
  slug: /^([a-zA-Z\d]+\-)*[a-zA-Z\d]+$|^$/, // hyphenated-slug or blank
  socialSecurity: /^\d{3}-\d{2}-\d{4}$|^$/, // ssn or blank
  subdomain: /^[a-z\d]+(?:-[a-z\d]+)*$/, // subdomain (does not check for max length restriction of 63 for DNS label)
  urlSafe: /^[a-zA-Z0-9_-]*$/, // alphanumeric characters, as well as _ and -
  clientId: /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/,

  isValidSubdomain(subdomain: string): boolean {
    return this.subdomain.test(subdomain) && subdomain.length <= 63 // 63 is max length possible for DNS label
  },

  strings: {
    clientId: '[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}',
    path: "(\\/[^\\s.]+)+", // very simplified
  }
};
